export default {"src":"/uk/_next/static/media/state-street.0687e4f8.svg","height":426,"width":1573,"blurWidth":0,"blurHeight":0};